import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support-dashboard',
  templateUrl: './support.dashboard.view.html',
  styleUrls: ['./support.dashboard.view.css']
})
export class SupportDashboardView implements OnInit {

  constructor() {}
  ngOnInit() {
  }

}
